/**
 * Browser entry point for Assembler library
 * This file exports only the browser-compatible modules
 */

// Common utilities
export { AssemblerConfig, CommonUtil, findMatchingCloseTag, isAlphaNumeric, normalizeFileContent, parseComponentReusePattern, removeRemainingSlotPlaceholders, replaceCaseInsensitive, utf16Len } from '../../../Assembler/dist/common/commonUtil.js';

// Model classes
export { JsonArrayPlaceholder, JsonArraySkipPlaceholder, JsonKeyPlaceholder, OperationsMetadata, PreprocessedTemplate, ReplacementMapping, ReplacementType, SlotPlaceholder, SlottedTemplate, TemplateOperation, TemplatePlaceholder } from '../../../Assembler/dist/model/index.js';

// JSON utilities
export { JsonMergeUtil, mergeTemplateWithJson } from '../../../Assembler/dist/base/engine/jsonMergeUtil.js';

// Engines (pure algorithms)
export { EngineNormal } from '../../../Assembler/dist/normal/engine/engineNormal.js';
export { EnginePreProcess } from '../../../Assembler/dist/preprocess/engine/enginePreProcess.js';

// Main loaders (with fromDict for client-side use)
export { LoaderNormal } from '../../../Assembler/dist/normal/loader/loaderNormal.js';
export { LoaderPreProcess } from '../../../Assembler/dist/preprocess/loader/loaderPreProcess.js';

// JSON data structures
export { JsonUtility } from '../../../Assembler/dist/app/jsonUtility.js';
export { JsonArray, JsonObject, JsonValue } from '../../../Assembler/dist/app/json/jsonValue.js';

// Browser-compatible Logger (from Arshu - aliased by build.js)
export { LogLevel, Logger } from '../../../Arshu/dist/logger/LoggerBrowser.js';

// AssemblerClient - Core client-side merge logic (lives in AssemblerQuality)
export { AssemblerClient } from '../../../AssemblerQuality/dist/apiclient/assemblerClient.js';

// PhaseTiming - AssemblerClient.getComponentsClient takes the call chain's timing value; the browser tier
// constructs a disabled one (new PhaseTiming(false)), as the web servers do when TrackTime is off.
export { PhaseTiming } from '../../../Assembler/dist/base/timing/phaseTiming.js';

// RegistryStore - For registering IData handlers (needed for dynamic data in client mode)
export { RegistryStore } from '../../../Assembler/dist/registry/registryStore.js';
// Base classes the AppSite-local client handlers extend (AppSites/<AppSite>/Handler/*.js register themselves into
// RegistryStore through window.ArshuAssembler). The bundle carries NO handler except the system views below.
export { IRegistry } from '../../../Assembler/dist/registry/iface/iRegistry.js';
export { IData } from '../../../Assembler/dist/registry/iface/iData.js';
export { IClientData } from '../../../Assembler/dist/registry/iface/iClientData.js';
export { IClient } from '../../../Assembler/dist/registry/iface/iClient.js';
export { IAction } from '../../../Assembler/dist/registry/iface/iAction.js';
export { IAppSite } from '../../../Assembler/dist/registry/iface/iAppSite.js';
export { AppSiteResult } from '../../../Assembler/dist/registry/iface/appSiteResult.js';
export { IDataSource } from '../../../Assembler/dist/registry/iface/iDataSource.js';

// System registrar - the only handlers delivered by bundling (BaseView, RuleView, HandlerView).
export { RegisterSystem } from '../../../Assembler/dist/registrySystem/registerSystem.js';
